import { render, staticRenderFns } from "./CTabs.vue?vue&type=template&id=4b8b806e"
import script from "./CTabs.vue?vue&type=script&lang=js"
export * from "./CTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports